import React from 'react';
import moment from 'moment';
import { ExpandableText, TextToolTip } from 'components';
import { Images, isAdmin, userInfo } from 'utils';

export const NotesMultipleCard = ({
                                    svgSrc, note, handleEditNote = () => {
  }, handleDeleteNote = () => {
  },
                                  }) => {
  return (
    <div className="notes-multiple-card-wrapper">
      <div className="notes-multiple-card-svg_note_info">
        <div className="notes-multiple-card-svg_not">
          {svgSrc &&
            <div className="notes-multiple-card-svg-wrapper">
              <img src={svgSrc} alt="note" />
            </div>
          }

          {note?.text &&
            <ExpandableText htmlContent={note?.text} />
          }
        </div>

        <div className="notes-multiple-card-info">
          {note?.createdDate &&
            <>
              <p className="notes-multiple-card-info-created-text" style={{ whiteSpace: 'nowrap' }}>
                {moment.utc(note?.createdDate).format('MM/DD/YYYY')}
              </p>
              <p className="notes-multiple-card-info-created-text" style={{ whiteSpace: 'nowrap' }}>
                {moment(note?.createdDate).format('LT')}
              </p>
            </>
          }
          {note?.user && (note?.user?.firstName || note?.user?.lastName) &&
            <>
              <p className="notes-multiple-card-info-created-text" style={{ whiteSpace: 'nowrap', marginLeft: 3 }}>
                Created by:
              </p>
              <TextToolTip
                classNameText="notes-multiple-card-info-created-text"
                text={`${note?.user?.firstName} ${note?.user?.lastName}`}
                content={`${note?.user?.firstName} ${note?.user?.lastName}`}
              />
            </>
          }
        </div>
      </div>

      <div className="notes-multiple-card-actions">
        <div className="align-center" style={{ gap: 10 }}>
          {isAdmin &&
            <button className="reset-btn notes-multiple-card-edit" onClick={handleEditNote}>
              <img src={Images.edit} alt="edit" />
            </button>
          }
          {
            (isAdmin || (note?.user?._id === userInfo?.id)) &&
            <button
              className="reset-btn notes-multiple-card-delete"
              onClick={handleDeleteNote}
            >
              <img src={Images.redTrash} alt="delete" />
            </button>
          }
        </div>
      </div>
    </div>
  );
};

